import type { ReactNode } from 'react';

import styles from './HorizontalList.module.css';

export interface HorizontalListProps {
  /** The items to display. */
  values: ReactNode[];
  /** The separator to use. */
  separator?: ReactNode;
}

/** Represents a component to show text separated by a given separator in a horizontal direction. */
export const HorizontalList = ({ values, separator = '•' }: HorizontalListProps) => {
  return (
    <div className={styles['horizontal-list-wrapper']}>
      {values.map((value, index) => (
        <span className={styles['horizontal-list-value']} key={`${value?.toString()}-${index}`}>
          {value}
          {index < values.length - 1 && <span className={styles['horizontal-list-separator']}>{separator}</span>}
        </span>
      ))}
    </div>
  );
};
